// vendors
import { useQuery, useMutation } from 'react-query';
import React, { useState, useEffect } from 'react';

// commons
import { Modal, Selecter, Button } from 'lego-dist';

// hooks
import { useTranslation } from 'react-i18next';

// queries
import { getCenterQuery, moveStudentsQuery } from '../queryConfig';

// styles
import {
  Body,
  BodySelecterWrapper,
  BodyButtonWrapper,
} from './MoveStudentsModal.styled';

// constants
const defaultButtonProps = {
  flat: true,
  fill: true,
  rounded: true,
  maxWidth: 120,
  color: '#75B753',
};

// interfaces
interface MoveStudentsModalProps {
  showModal: boolean;
  currentClassroom: any;
  setShowModal: Function;
  selectedStudents: object;
  onMovedStudents: Function;
}

// eslint-disable-next-line import/prefer-default-export
export function MoveStudentsModal({
  setShowModal,
  onMovedStudents,
  currentClassroom,
  showModal = false,
  selectedStudents = {},
}: MoveStudentsModalProps) {
  const { data: centers = [], refetch: fetchCenters } = useQuery(
    getCenterQuery.key,
    () => getCenterQuery.resource(currentClassroom?.babies[0]?.center_id),
    getCenterQuery.config,
  );
  const { t: translate } = useTranslation();
  const [selectedCenter, setSelectedCenter] = useState<any>();
  const [selectedClassroom, setSelectedClassroom] = useState<any>({});

  const [moveStudents, { isSuccess: moveStudentsSuccess }] = useMutation(
    moveStudentsQuery.resource,
  );

  const onMoveStudents = () => {
    const body = {
      baby_ids: Object.keys(selectedStudents),
      center_attributes: {
        id: selectedCenter.external_id,
        group_ids: [selectedClassroom.external_id],
      },
    };
    const currentCenterId = currentClassroom?.babies[0]?.center_id;
    moveStudents({ body, currentCenterId });
  };

  const getCenters = () => {
    if (centers.length > 0) {
      return centers?.map((center: any) => ({
        ...center,
        value: center.id,
        label: center.name,
      }));
    }
    fetchCenters();
    return [];
  };

  const getClassrooms = () => {
    if (selectedCenter) {
      return selectedCenter?.groups.map((group: any) => ({
        ...group,
        value: group.id,
        label: group.name,
      }));
    }
    return [];
  };

  const onChangeSelectedCenter = (selectedCenter_: any) => {
    setSelectedCenter(selectedCenter_);
    setSelectedClassroom({});
  };

  useEffect(() => {
    if (moveStudentsSuccess) {
      setShowModal(!showModal);
      if (onMovedStudents) {
        onMovedStudents();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moveStudentsSuccess]);

  return (
    <Modal
      openModal={showModal}
      headerColor='#0086D8'
      closeButtonColor="#ffffff"
      title={translate('settings:MOVE_STUDENTS')}
      onClosedModal={() => setShowModal(!showModal)}
    >
      {() => (
        <Body>
          {translate('settings:SELECT_CENTER_AND_CLASSROOM')}
          <BodySelecterWrapper>
            <Selecter
              name="centers"
              data={getCenters()}
              value={selectedCenter?.value}
              onChange={onChangeSelectedCenter}
              placeholder={translate('settings:CHOOSE_CENTER')}
              search
            />
          </BodySelecterWrapper>
          <BodySelecterWrapper disabled={!selectedCenter}>
            <Selecter
              name="classrooms"
              data={getClassrooms()}
              onChange={setSelectedClassroom}
              value={selectedClassroom?.value}
              placeholder={translate('settings:CHOOSE_CLASSROOM')}
              search
            />
          </BodySelecterWrapper>
          <BodyButtonWrapper>
            <Button
              {...defaultButtonProps}
              onClick={onMoveStudents}
              disabled={Object.keys(selectedClassroom).length === 0}
            >
              {translate('settings:MOVE')}
            </Button>
          </BodyButtonWrapper>
        </Body>
      )}
    </Modal>
  );
}
